import { Component, inject, OnInit } from '@angular/core';
import { UserService } from 'app/services';

@Component({
  selector: 'app-logout',
  standalone: true,
  template: '',
})
export class LogoutComponent implements OnInit {
  private userService = inject(UserService);
  ngOnInit(): void {
    this.userService.disconnect();
    window.location.href = '/home';
  }
}
